import React, { lazy, Suspense } from 'react';
import './Deliver.css';
import { getStoredData } from "../../json/fetchData.js";

// ✅ Lazy load the components
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));
const ContentModel = lazy(() => import("../../components/ContentModel/ContentModel.js"));

const Deliver = () => {
  const totalData = getStoredData();
  const data = totalData ? totalData["27"] : {};

  return (
    <div>
      {/* ✅ Wrap lazy-loaded components in Suspense */}
      <Suspense fallback={<p>Loading intro...</p>}>
        <AllIntroTemplate 
          image={data.Image} 
          title={data.Title} 
          page={totalData ? totalData["0"] : {}}
        />
      </Suspense>

      <Suspense fallback={<p>Loading content...</p>}>
        <ContentModel data={totalData ? totalData["27"] : {}} />
      </Suspense>
    </div>
  );
};

export default Deliver;
